import script from "./BaseHeading.vue?vue&type=script&lang=ts"
export * from "./BaseHeading.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__